import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { ComisionVendedor } from '../types/comision.types';
import { ComisionService } from '../services/comisionService';

interface ComisionState {
  comisiones: ComisionVendedor[];
  loading: boolean;
  error: string | null;

  fetchComisiones: () => Promise<void>;
  fetchByVendedor: (idVendedor: number) => Promise<void>;
  calcularComisiones: (fechaDesde?: string, fechaHasta?: string) => Promise<void>;
  clearError: () => void;
  reset: () => void;
}

const initialState = {
  comisiones: [],
  loading: false,
  error: null,
};

export const useComisionStore = create<ComisionState>()(
  devtools(
    (set) => ({
      ...initialState,

      fetchComisiones: async () => {
        set({ loading: true, error: null }, false, 'comision/fetchAll/start');
        try {
          const comisiones = await ComisionService.getAll();
          set({ comisiones, loading: false }, false, 'comision/fetchAll/success');
        } catch (error) {
          set({ loading: false, error: error instanceof Error ? error.message : 'Error al cargar comisiones' }, false, 'comision/fetchAll/error');
        }
      },

      fetchByVendedor: async (idVendedor: number) => {
        set({ loading: true, error: null }, false, 'comision/fetchByVendedor/start');
        try {
          const comisiones = await ComisionService.getByVendedor(idVendedor);
          set({ comisiones, loading: false }, false, 'comision/fetchByVendedor/success');
        } catch (error) {
          set({ loading: false, error: error instanceof Error ? error.message : 'Error al cargar comisiones' }, false, 'comision/fetchByVendedor/error');
        }
      },

      calcularComisiones: async (fechaDesde?: string, fechaHasta?: string) => {
        set({ loading: true, error: null }, false, 'comision/calcular/start');
        try {
          const comisiones = await ComisionService.calcular(fechaDesde, fechaHasta);
          set({ comisiones, loading: false }, false, 'comision/calcular/success');
        } catch (error) {
          set({ loading: false, error: error instanceof Error ? error.message : 'Error al calcular comisiones' }, false, 'comision/calcular/error');
          throw error;
        }
      },

      clearError: () => set({ error: null }, false, 'comision/clearError'),
      reset: () => set(initialState, false, 'comision/reset'),
    }),
    { name: 'comision-store' }
  )
);
